import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initAdvancedTracking } from '@/lib/tracking'

// Initialize advanced tracking
initAdvancedTracking();

createRoot(document.getElementById("root")!).render(<App />);
